import EngineModule from '@emersya/mpa-engine/src/app/client/EngineModule';
import { NS as PlannerFloorEditorNS } from '../components/PlannerFloorEditor/PlannerFloorEditor';

export default () => new EngineModule.UIEngineModule({
	type: 'ui',
	useFullWidth: false,
	id: 'totalExpo-viewer-planner-floor-editor',
	dependencies: [
		'viewer-planner',
		'oms-basket'
	],
	allowedCustomers: null,
	modulesBefore: ['product-editor'],
	modulesAfter: [],
	usableCondition: null,
	displayCondition: null,
	generateComponentConfiguration(): PlannerFloorEditorNS.Configuration {
		return {
			allFree: this.configuration.allFree ? true : false
		};
	}
});
